import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { shallowEqual } from "react-redux";

import { devices } from "../../config";
import { useAppSelector } from "../../redux/hooks";

export const H1 = styled.h1`
  margin: 0 0.5rem;
  text-decoration: none;
  font-weight: 400;
  @media only screen and ${devices.fullHD} {
    font-size: 1.8rem;
  }
`;

const CurrentTimeDiv = (): JSX.Element => {
  const { t } = useTranslation();

  const [timeZoneFromRedux]: [string] = useAppSelector(
    (state: RootState) => [state?.constantValues?.timeZone],
    shallowEqual
  );
  // console.info("timeZoneFromRedux:", timeZoneFromRedux);

  const [currentTimeDate, setCurrentTimeDate] = React.useState<string>("");
  // console.info("currentTimeDate:", currentTimeDate);

  React.useEffect(() => {
    const currentTimeZone: string = timeZoneFromRedux || Intl.DateTimeFormat().resolvedOptions().timeZone;
    // console.info("currentTimeZone:", currentTimeZone);

    const updateTime = (): void => {
      const now = new Date();
      const options = {
        timeZone: currentTimeZone,
        weekday: "long",
        year: "numeric",
        month: "2-digit",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };
      //* Format: Monday 27/10/2025 17:56:59
      const formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat("en-GB", options as Intl.DateTimeFormatOptions);
      // console.info("formatter:", formatter);
      setCurrentTimeDate(formatter.format(now));
    };

    updateTime(); // Initial call
    const intervalId: NodeJS.Timer = setInterval(updateTime, 1000); // Update every second
    return () => clearInterval(intervalId); // Cleanup on unmount or timezone change
  }, [timeZoneFromRedux]);

  const separateDayTimeDate = (dateStr: string) => {
    const [weekDay, date, time] = dateStr?.split(",")?.map((elem: string) => elem?.trim());
    const [day, month, year] = date?.split("/");
    const modifiedDate = `${year}.${month}.${day}`;
    // console.info("weekDay, modifiedDate, time:", weekDay, modifiedDate, time);
    return { weekDay, modifiedDate, time };
  };

  return (
    <React.Fragment>
      {currentTimeDate ? (
        <H1>
          <span style={{ fontSize: "65%", fontWeight: "500" }}>{`
        ${t(separateDayTimeDate(currentTimeDate)?.weekDay)}, 
        ${separateDayTimeDate(currentTimeDate)?.modifiedDate}, `}</span>
          {separateDayTimeDate(currentTimeDate)?.time}
        </H1>
      ) : null}
    </React.Fragment>
  );
};

export default CurrentTimeDiv;
